module.exports = __webpack_public_path__ + "img/prepareinterview.e5de5a31.svg";